const constant = {
    primaryColor: "#0F172B",
    borderColor: "#333",
    blackColor: "#000",
    secondaryColor: "#AF9074",
    footerColor: "#496184",
};
export default constant;  